import { motion } from "framer-motion";
import { GraduationCap, Quotes } from "@phosphor-icons/react";
import { TEAM, IMAGES } from "../data/site";
import { Reveal, Eyebrow } from "../components/Reveal";
import { CTABand } from "../components/CTABand";

export default function Team() {
  return (
    <main data-testid="team-page">
      <section className="relative overflow-hidden border-b border-border pt-40">
        <div className="mx-auto max-w-7xl px-5 pb-16 sm:px-8 sm:pb-24">
          <Reveal y={20}>
            <Eyebrow>Meet the team</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-display text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
              Clinicians who <em className="text-primary">listen.</em>
            </h1>
          </Reveal>
        </div>
        <Reveal>
          <div className="mx-auto max-w-7xl px-5 pb-20 sm:px-8">
            <div className="overflow-hidden">
              <motion.img
                src={IMAGES.teamGroup}
                alt="The DK Aesthetics team — Siobhan, Dee and Dr Landa"
                className="aspect-[16/8] w-full object-cover object-top"
                initial={{ scale: 1.08 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                data-testid="team-group-image"
              />
            </div>
            <p className="mt-4 text-xs uppercase tracking-[0.25em] text-muted-foreground">
              Siobhan Hall · Dee Kaur · Dr Amarjit Landa
            </p>
          </div>
        </Reveal>
      </section>

      {TEAM.map((m, i) => (
        <section
          key={m.id}
          id={m.id}
          className={`scroll-mt-24 border-b border-border py-20 sm:py-28 ${i % 2 === 1 ? "bg-secondary/30" : ""}`}
          data-testid={`team-member-${m.id}`}
        >
          <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 md:grid-cols-12">
            <Reveal className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <div className="overflow-hidden">
                {m.image ? (
                  <motion.img
                    src={m.image}
                    alt={m.name}
                    className="aspect-[3/4] w-full object-cover object-top"
                    initial={{ scale: 1.1 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
                    data-testid={`team-photo-${m.id}`}
                  />
                ) : (
                  <div className="flex aspect-[3/4] w-full items-center justify-center border border-primary/15 bg-accent/60" data-testid={`team-photo-${m.id}`}>
                    <span className="font-display text-8xl font-light italic text-primary/40">
                      {m.name.replace("Dr. ", "").split(" ").map((w) => w[0]).slice(0, 2).join("")}
                    </span>
                  </div>
                )}
              </div>
            </Reveal>
            <div className={`flex flex-col justify-center md:col-span-8 ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <Reveal>
                <span className="font-display text-6xl font-light italic text-primary/20">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-2 font-display text-4xl font-light tracking-tight sm:text-5xl">{m.name}</h2>
                <p className="mt-2 text-xs font-medium uppercase tracking-[0.25em] text-primary">{m.title}</p>
                <p className="mt-4 flex items-start gap-2 text-sm font-light text-muted-foreground">
                  <GraduationCap size={18} className="mt-0.5 shrink-0 text-primary" />
                  {m.credentials}
                </p>
              </Reveal>
              <Reveal delay={0.12}>
                <div className="mt-7 space-y-4">
                  {m.bio.map((p, j) => (
                    <p key={j} className="max-w-2xl text-sm font-light leading-relaxed text-foreground/85 sm:text-base">
                      {p}
                    </p>
                  ))}
                </div>
                <blockquote className="mt-8 flex max-w-2xl gap-4 border-l-2 border-primary bg-secondary/50 p-6">
                  <Quotes size={22} weight="fill" className="shrink-0 text-primary" />
                  <p className="font-display text-lg font-light italic leading-relaxed">{m.quote}</p>
                </blockquote>
              </Reveal>
            </div>
          </div>
        </section>
      ))}

      <CTABand />
    </main>
  );
}
